export default [
  {
    "id": "AIDS",
    "group": "First Author",
    "percentage": 50,
    "volume": 22112
  },
  {
    "id": "Allergy and Immunology",
    "group": "First Author",
    "percentage": 31.8,
    "volume": 44635
  },
  {
    "id": "Anatomy",
    "group": "First Author",
    "percentage": 42.7,
    "volume": 9220
  },
  {
    "id": "Anesthesiology",
    "group": "First Author",
    "percentage": 35.7,
    "volume": 30335
  },
  {
    "id": "Anthropology",
    "group": "First Author",
    "percentage": 49.3,
    "volume": 6079
  },
  {
    "id": "Anti-infective Agents",
    "group": "First Author",
    "percentage": 47.5,
    "volume": 22230
  },
  {
    "id": "Antineoplastic Agents",
    "group": "First Author",
    "percentage": 43.1,
    "volume": 2900
  },
  {
    "id": "Audiology",
    "group": "First Author",
    "percentage": 49.9,
    "volume": 5843
  },
  {
    "id": "Behavioral Sciences",
    "group": "First Author",
    "percentage": 50,
    "volume": 10539
  },
  {
    "id": "Biochemistry",
    "group": "First Author",
    "percentage": 43.6,
    "volume": 236237
  },
  {
    "id": "Bioinformatics",
    "group": "First Author",
    "percentage": 23.4,
    "volume": 15420
  },
  {
    "id": "Biology",
    "group": "First Author",
    "percentage": 43.4,
    "volume": 102267
  },
  {
    "id": "Biomedical Engineering",
    "group": "First Author",
    "percentage": 27.7,
    "volume": 45519
  },
  {
    "id": "Biophysics",
    "group": "First Author",
    "percentage": 34.6,
    "volume": 79256
  },
  {
    "id": "Biotechnology",
    "group": "First Author",
    "percentage": 44.7,
    "volume": 45849
  },
  {
    "id": "Botany",
    "group": "First Author",
    "percentage": 45.7,
    "volume": 33749
  },
  {
    "id": "Brain",
    "group": "First Author",
    "percentage": 47.2,
    "volume": 45458
  },
  {
    "id": "Cardiology",
    "group": "First Author",
    "percentage": 27,
    "volume": 174538
  },
  {
    "id": "Cell Biology",
    "group": "First Author",
    "percentage": 48.5,
    "volume": 122368
  },
  {
    "id": "Chemistry",
    "group": "First Author",
    "percentage": 35,
    "volume": 249128
  },
  {
    "id": "Chemistry Techniques, Analytical",
    "group": "First Author",
    "percentage": 41.3,
    "volume": 73522
  },
  {
    "id": "Clinical Laboratory Techniques",
    "group": "First Author",
    "percentage": 41,
    "volume": 8786
  },
  {
    "id": "Communicable Diseases",
    "group": "First Author",
    "percentage": 47,
    "volume": 35332
  },
  {
    "id": "Complementary Therapies",
    "group": "First Author",
    "percentage": 48.4,
    "volume": 7234
  },
  {
    "id": "Computational Biology",
    "group": "First Author",
    "percentage": 33.3,
    "volume": 8811
  },
  {
    "id": "Critical Care",
    "group": "First Author",
    "percentage": 39,
    "volume": 11273
  },
  {
    "id": "Dentistry",
    "group": "First Author",
    "percentage": 41.8,
    "volume": 52786
  },
  {
    "id": "Dermatology",
    "group": "First Author",
    "percentage": 49.9,
    "volume": 59121
  },
  {
    "id": "Diagnostic Imaging",
    "group": "First Author",
    "percentage": 32.6,
    "volume": 23423
  },
  {
    "id": "Drug Therapy",
    "group": "First Author",
    "percentage": 41.8,
    "volume": 13561
  },
  {
    "id": "Education",
    "group": "First Author",
    "percentage": 61.4,
    "volume": 1741
  },
  {
    "id": "Embryology",
    "group": "First Author",
    "percentage": 48,
    "volume": 3044
  },
  {
    "id": "Emergency Medicine",
    "group": "First Author",
    "percentage": 26.3,
    "volume": 6294
  },
  {
    "id": "Endocrinology",
    "group": "First Author",
    "percentage": 49.5,
    "volume": 67808
  },
  {
    "id": "Environmental Health",
    "group": "First Author",
    "percentage": 45.6,
    "volume": 76199
  },
  {
    "id": "Epidemiology",
    "group": "First Author",
    "percentage": 50,
    "volume": 19862
  },
  {
    "id": "Ethics",
    "group": "First Author",
    "percentage": 48,
    "volume": 4258
  },
  {
    "id": "Gastroenterology",
    "group": "First Author",
    "percentage": 34.5,
    "volume": 104572
  },
  {
    "id": "General Surgery",
    "group": "First Author",
    "percentage": 25,
    "volume": 218595
  },
  {
    "id": "Genetics",
    "group": "First Author",
    "percentage": 47.7,
    "volume": 80648
  },
  {
    "id": "Genetics, Medical",
    "group": "First Author",
    "percentage": 49.3,
    "volume": 7818
  },
  {
    "id": "Geriatrics",
    "group": "First Author",
    "percentage": 50,
    "volume": 25967
  },
  {
    "id": "Gynecology",
    "group": "First Author",
    "percentage": 50,
    "volume": 47698
  },
  {
    "id": "Health Services",
    "group": "First Author",
    "percentage": 49.8,
    "volume": 14838
  },
  {
    "id": "Health Services Research",
    "group": "First Author",
    "percentage": 62.5,
    "volume": 14549
  },
  {
    "id": "Hematology",
    "group": "First Author",
    "percentage": 45.7,
    "volume": 56957
  },
  {
    "id": "History of Medicine",
    "group": "First Author",
    "percentage": 45.2,
    "volume": 2884
  },
  {
    "id": "Hospitals",
    "group": "First Author",
    "percentage": 35.4,
    "volume": 1471
  },
  {
    "id": "Immunology",
    "group": "First Author",
    "percentage": 49.5,
    "volume": 78464
  },
  {
    "id": "Internal Medicine",
    "group": "First Author",
    "percentage": 37.6,
    "volume": 1247
  },
  {
    "id": "Jurisprudence",
    "group": "First Author",
    "percentage": 49.4,
    "volume": 3587
  },
  {
    "id": "Laboratory Animal Science",
    "group": "First Author",
    "percentage": 49.9,
    "volume": 3085
  },
  {
    "id": "Medical Informatics",
    "group": "First Author",
    "percentage": 33.1,
    "volume": 17635
  },
  {
    "id": "Medicine",
    "group": "First Author",
    "percentage": 42.1,
    "volume": 882348
  },
  {
    "id": "Metabolism",
    "group": "First Author",
    "percentage": 49.5,
    "volume": 17026
  },
  {
    "id": "Microbiology",
    "group": "First Author",
    "percentage": 49.9,
    "volume": 120419
  },
  {
    "id": "Midwifery",
    "group": "First Author",
    "percentage": 82,
    "volume": 3164
  },
  {
    "id": "Molecular Biology",
    "group": "First Author",
    "percentage": 44.5,
    "volume": 96950
  },
  {
    "id": "Multidisciplinary",
    "group": "First Author",
    "percentage": 44.3,
    "volume": 235271
  },
  {
    "id": "Nanotechnology",
    "group": "First Author",
    "percentage": 35.1,
    "volume": 31168
  },
  {
    "id": "Neoplasms",
    "group": "First Author",
    "percentage": 46.6,
    "volume": 248023
  },
  {
    "id": "Nephrology",
    "group": "First Author",
    "percentage": 40.1,
    "volume": 40186
  },
  {
    "id": "Neurology",
    "group": "First Author",
    "percentage": 42.2,
    "volume": 326933
  },
  {
    "id": "Neurosurgery",
    "group": "First Author",
    "percentage": 24.4,
    "volume": 4621
  },
  {
    "id": "Nuclear Medicine",
    "group": "First Author",
    "percentage": 28.6,
    "volume": 3779
  },
  {
    "id": "Nursing",
    "group": "First Author",
    "percentage": 80.7,
    "volume": 64044
  },
  {
    "id": "Nutritional Sciences",
    "group": "First Author",
    "percentage": 62.2,
    "volume": 67478
  },
  {
    "id": "Obstetrics",
    "group": "First Author",
    "percentage": 50,
    "volume": 11487
  },
  {
    "id": "Occupational Medicine",
    "group": "First Author",
    "percentage": 49.9,
    "volume": 5474
  },
  {
    "id": "Opthalmology",
    "group": "First Author",
    "percentage": 36,
    "volume": 102615
  },
  {
    "id": "Orthodontics",
    "group": "First Author",
    "percentage": 41.3,
    "volume": 5837
  },
  {
    "id": "Orthopedics",
    "group": "First Author",
    "percentage": 18.3,
    "volume": 46351
  },
  {
    "id": "Otolaryngology",
    "group": "First Author",
    "percentage": 34.7,
    "volume": 34138
  },
  {
    "id": "Palliative Care",
    "group": "First Author",
    "percentage": 65.5,
    "volume": 3516
  },
  {
    "id": "Parasitology",
    "group": "First Author",
    "percentage": 48.7,
    "volume": 18392
  },
  {
    "id": "Pathology",
    "group": "First Author",
    "percentage": 48.7,
    "volume": 34990
  },
  {
    "id": "Pediatrics",
    "group": "First Author",
    "percentage": 50,
    "volume": 123528
  },
  {
    "id": "Perinatology",
    "group": "First Author",
    "percentage": 50,
    "volume": 5744
  },
  {
    "id": "Pharmacology",
    "group": "First Author",
    "percentage": 45.7,
    "volume": 166140
  },
  {
    "id": "Physical and Rehabilitation Medicine",
    "group": "First Author",
    "percentage": 58.9,
    "volume": 15313
  },
  {
    "id": "Physiology",
    "group": "First Author",
    "percentage": 42.1,
    "volume": 103121
  },
  {
    "id": "Primary Health Care",
    "group": "First Author",
    "percentage": 36.7,
    "volume": 16845
  },
  {
    "id": "Psychiatry",
    "group": "First Author",
    "percentage": 49.1,
    "volume": 97850
  },
    {
    "id": "Psychology",
    "group": "First Author",
    "percentage": 49.8,
    "volume": 93607
  },
  {
    "id": "Psychopharmacology",
    "group": "First Author",
    "percentage": 47.8,
    "volume": 11402
  },
  {
    "id": "Psychophysiology",
    "group": "First Author",
    "percentage": 49.6,
    "volume": 8818
  },
  {
    "id": "Public Health",
    "group": "First Author",
    "percentage": 60,
    "volume": 74710
  },
  {
    "id": "Pulmonary Medicine",
    "group": "First Author",
    "percentage": 50,
    "volume": 30952
  },
  {
    "id": "Radiology",
    "group": "First Author",
    "percentage":32.7,
    "volume": 41627
  },
  {
    "id": "Radiotherapy",
    "group": "First Author",
    "percentage": 32.9,
    "volume": 2006
  },
  {
    "id": "Reproductive Medicine",
    "group": "First Author",
    "percentage": 50,
    "volume": 22418
  },
  {
    "id": "Rheumatology",
    "group": "First Author",
    "percentage": 47.8,
    "volume": 34852
  },
  {
    "id": "Sexually Transmitted Diseases",
    "group": "First Author",
    "percentage": 61.8,
    "volume": 3592
  },
  {
    "id": "Social Sciences",
    "group": "First Author",
    "percentage": 60,
    "volume": 8213
  },
  {
    "id": "Speech-Language Pathology",
    "group": "First Author",
    "percentage": 76.8,
    "volume": 4780
  },
  {
    "id": "Sports Medicine",
    "group": "First Author",
    "percentage": 39,
    "volume": 6623
  },
  {
    "id": "Statistics as Topics",
    "group": "First Author",
    "percentage": 31.6,
    "volume": 4201
  },
  {
    "id": "Substance-Related Disorders",
    "group": "First Author",
    "percentage": 49.9,
    "volume": 25475
  },
  {
    "id": "Therapeutics",
    "group": "First Author",
    "percentage": 44.3,
    "volume": 6877
  },
  {
    "id": "Toxicology",
    "group": "First Author",
    "percentage": 48.4,
    "volume": 60334
  },
  {
    "id": "Transplantation",
    "group": "First Author",
    "percentage": 37.1,
    "volume": 25057
  },
  {
    "id": "Traumatology",
    "group": "First Author",
    "percentage": 31.5,
    "volume": 33311
  },
  {
    "id": "Tropical Medicine",
    "group": "First Author",
    "percentage": 47.5,
    "volume": 14841
  },
  {
    "id": "Unclassified",
    "group": "First Author",
    "percentage": 42.3,
    "volume": 149970
  },
  {
    "id": "Urology",
    "group": "First Author",
    "percentage": 21.7,
    "volume": 55644
  },
  {
    "id": "Vascular Diseases",
    "group": "First Author",
    "percentage": 37.2,
    "volume": 43173
  },
  {
    "id": "Veterinary Medicine",
    "group": "First Author",
    "percentage": 49.9,
    "volume": 30726
  },  
  {
    "id": "AIDS",
    "group": "Last Author",
    "percentage": 42.3,
    "volume": 22386
  },
  {
    "id": "Allergy and Immunology",
    "group": "Last Author",
    "percentage": 31.8,
    "volume": 45622
  },
  {
    "id": "Anatomy",
    "group": "Last Author",
    "percentage": 29.1,
    "volume": 9394
  },
  {
    "id": "Anesthesiology",
    "group": "Last Author",
    "percentage": 25.5,
    "volume": 29837
  },
  {
    "id": "Anthropology",
    "group": "Last Author",
    "percentage": 34.1,
    "volume": 5966
  },
  {
    "id": "Anti-infective Agents",
    "group": "Last Author",
    "percentage": 26.9,
    "volume": 22878
  },
  {
    "id": "Antineoplastic Agents",
    "group": "Last Author",
    "percentage": 26.3,
    "volume": 2855
  },
  {
    "id": "Audiology",
    "group": "Last Author",
    "percentage": 42.6,
    "volume": 5981
  },
  {
    "id": "Behavioral Sciences",
    "group": "Last Author",
    "percentage": 40.9,
    "volume": 10401
  },
  {
    "id": "Biochemistry",
    "group": "Last Author",
    "percentage": 26.2,
    "volume": 246862
  },
  {
    "id": "Bioinformatics",
    "group": "Last Author",
    "percentage": 20.7,
    "volume": 16441
  },
  {
    "id": "Biology",
    "group": "Last Author",
    "percentage": 27.8,
    "volume": 104691
  },
  {
    "id": "Biomedical Engineering",
    "group": "Last Author",
    "percentage": 20.3,
    "volume": 47748
  },
  {
    "id": "Biophysics",
    "group": "Last Author",
    "percentage": 22.3,
    "volume": 80745
  },
  {
    "id": "Biotechnology",
    "group": "Last Author",
    "percentage": 29,
    "volume": 45541
  },
  {
    "id": "Botany",
    "group": "Last Author",
    "percentage": 29.9,
    "volume": 34667
  },
  {
    "id": "Brain",
    "group": "Last Author",
    "percentage": 28.8,
    "volume": 46470
  },
  {
    "id": "Cardiology",
    "group": "Last Author",
    "percentage": 16.6,
    "volume": 176672
  },
  {
    "id": "Cell Biology",
    "group": "Last Author",
    "percentage": 29.7,
    "volume": 122368
  },
  {
    "id": "Chemistry",
    "group": "Last Author",
    "percentage": 20.7,
    "volume": 260902
  },
  {
    "id": "Chemistry Techniques, Analytical",
    "group": "Last Author",
    "percentage": 26,
    "volume": 76146
  },
  {
    "id": "Clinical Laboratory Techniques",
    "group": "Last Author",
    "percentage": 24.8,
    "volume": 9022
  },
  {
    "id": "Communicable Diseases",
    "group": "Last Author",
    "percentage": 33.1,
    "volume": 35546
  },
  {
    "id": "Complementary Therapies",
    "group": "Last Author",
    "percentage": 37.8,
    "volume": 7017
  },
  {
    "id": "Computational Biology",
    "group": "Last Author",
    "percentage": 23.2,
    "volume": 9322
  },
  {
    "id": "Critical Care",
    "group": "Last Author",
    "percentage": 27.3,
    "volume": 11280
  },
  {
    "id": "Dentistry",
    "group": "Last Author",
    "percentage": 31.3,
    "volume": 53067
  },
  {
    "id": "Dermatology",
    "group": "Last Author",
    "percentage": 36.9,
    "volume": 58737
  },
  {
    "id": "Diagnostic Imaging",
    "group": "Last Author",
    "percentage": 21.3,
    "volume": 24227
  },
  {
    "id": "Drug Therapy",
    "group": "Last Author",
    "percentage": 27,
    "volume": 13580
  },
  {
    "id": "Education",
    "group": "Last Author",
    "percentage": 48.9,
    "volume": 1740
  },
  {
    "id": "Embryology",
    "group": "Last Author",
    "percentage": 31,
    "volume": 3119
  },
  {
    "id": "Emergency Medicine",
    "group": "Last Author",
    "percentage": 18.5,
    "volume": 6242
  },
  {
    "id": "Endocrinology",
    "group": "Last Author",
    "percentage": 33.4,
    "volume": 68912
  },
  {
    "id": "Environmental Health",
    "group": "Last Author",
    "percentage": 30.6,
    "volume": 77972
  },
  {
    "id": "Epidemiology",
    "group": "Last Author",
    "percentage": 38.9,
    "volume": 20004
  },
  {
    "id": "Ethics",
    "group": "Last Author",
    "percentage": 43.7,
    "volume": 4231
  },
  {
    "id": "Gastroenterology",
    "group": "Last Author",
    "percentage": 20.4,
    "volume": 105152
  },
  {
    "id": "General Surgery",
    "group": "Last Author",
    "percentage": 16.6,
    "volume": 215851
  },
  {
    "id": "Genetics",
    "group": "Last Author",
    "percentage": 30.3,
    "volume": 83383
  },
  {
    "id": "Genetics, Medical",
    "group": "Last Author",
    "percentage": 28.3,
    "volume": 8041
  },
  {
    "id": "Geriatrics",
    "group": "Last Author",
    "percentage": 41.2,
    "volume": 25967
  },
  {
    "id": "Gynecology",
    "group": "Last Author",
    "percentage": 40.6,
    "volume": 47927
  },
  {
    "id": "Health Services",
    "group": "Last Author",
    "percentage": 46.1,
    "volume": 15000
  },
  {
    "id": "Health Services Research",
    "group": "Last Author",
    "percentage": 44.2,
    "volume": 14867
  },
  {
    "id": "Hematology",
    "group": "Last Author",
    "percentage": 28.9,
    "volume": 57835
  },
  {
    "id": "History of Medicine",
    "group": "Last Author",
    "percentage": 34.7,
    "volume": 2826
  },
  {
    "id": "Hospitals",
    "group": "Last Author",
    "percentage": 35.4,
    "volume": 1463
  },
  {
    "id": "Immunology",
    "group": "Last Author",
    "percentage": 32.9,
    "volume": 80302
  },
  {
    "id": "Internal Medicine",
    "group": "Last Author",
    "percentage": 32.6,
    "volume": 1236
  },
  {
    "id": "Jurisprudence",
    "group": "Last Author",
    "percentage": 36.1,
    "volume": 3069
  },
  {
    "id": "Laboratory Animal Science",
    "group": "Last Author",
    "percentage": 36.1,
    "volume": 3069
  },
  {
    "id": "Medical Informatics",
    "group": "Last Author",
    "percentage": 27.3,
    "volume": 18462
  },
  {
    "id": "Medicine",
    "group": "Last Author",
    "percentage": 30.1,
    "volume": 889857
  },
  {
    "id": "Metabolism",
    "group": "Last Author",
    "percentage": 34.8,
    "volume": 17218
  },
  {
    "id": "Microbiology",
    "group": "Last Author",
    "percentage": 33.1,
    "volume": 122907
  },
  {
    "id": "Midwifery",
    "group": "Last Author",
    "percentage": 71.3,
    "volume": 3165
  },
  {
    "id": "Molecular Biology",
    "group": "Last Author",
    "percentage": 28.2,
    "volume": 100556
  },
  {
    "id": "Multidisciplinary",
    "group": "Last Author",
    "percentage": 28.6,
    "volume": 244670
  },
  {
    "id": "Nanotechnology",
    "group": "Last Author",
    "percentage": 23.5,
    "volume": 33036
  },
  {
    "id": "Neoplasms",
    "group": "Last Author",
    "percentage": 31.6,
    "volume": 251579
  },
  {
    "id": "Nephrology",
    "group": "Last Author",
    "percentage": 22.6,
    "volume": 40613
  },
  {
    "id": "Neurology",
    "group": "Last Author",
    "percentage": 26.7,
    "volume": 333210
  },
  {
    "id": "Neurosurgery",
    "group": "Last Author",
    "percentage": 15.4,
    "volume": 4398
  },
  {
    "id": "Nuclear Medicine",
    "group": "Last Author",
    "percentage": 17.0,
    "volume": 3923
  },
  {
    "id": "Nursing",
    "group": "Last Author",
    "percentage": 72.8,
    "volume": 64682
  },
  {
    "id": "Nutritional Sciences",
    "group": "Last Author",
    "percentage": 43.3,
    "volume": 68215
  },
  {
    "id": "Obstetrics",
    "group": "Last Author",
    "percentage": 43.1,
    "volume": 11508
  },
  {
    "id": "Occupational Medicine",
    "group": "Last Author",
    "percentage": 41,
    "volume": 5524
  },
  {
    "id": "Opthalmology",
    "group": "Last Author",
    "percentage": 24.3,
    "volume": 104264
  },
  {
    "id": "Orthodontics",
    "group": "Last Author",
    "percentage": 28.9,
    "volume": 5787
  },
  {
    "id": "Orthopedics",
    "group": "Last Author",
    "percentage": 12.9,
    "volume": 46880
  },
  {
    "id": "Otolaryngology",
    "group": "Last Author",
    "percentage": 23.1,
    "volume": 34200
  },
  {
    "id": "Palliative Care",
    "group": "Last Author",
    "percentage": 51.9,
    "volume": 3551
  },
  {
    "id": "Parasitology",
    "group": "Last Author",
    "percentage": 35.7,
    "volume": 18244
  },
  {
    "id": "Pathology",
    "group": "Last Author",
    "percentage": 31.4,
    "volume": 34903
  },
  {
    "id": "Pediatrics",
    "group": "Last Author",
    "percentage": 39.5,
    "volume": 123528
  },
  {
    "id": "Perinatology",
    "group": "Last Author",
    "percentage": 43.3,
    "volume": 5840
  },
  {
    "id": "Pharmacology",
    "group": "Last Author",
    "percentage": 32.2,
    "volume": 168466
  },
  {
    "id": "Physical and Rehabilitation Medicine",
    "group": "Last Author",
    "percentage": 49.7,
    "volume": 15476
  },
  {
    "id": "Physiology",
    "group": "Last Author",
    "percentage": 26.3,
    "volume": 106607
  },
  {
    "id": "Primary Health Care",
    "group": "Last Author",
    "percentage": 43.6,
    "volume": 16941
  },
  {
    "id": "Psychiatry",
    "group": "Last Author",
    "percentage": 36.1,
    "volume": 98553
  },
  {
    "id": "Psychology",
    "group": "Last Author",
    "percentage": 40.1,
    "volume": 94068
  },
  {
    "id": "Psychopharmacology",
    "group": "Last Author",
    "percentage": 30.5,
    "volume": 11378
  },
  {
    "id": "Psychophysiology",
    "group": "Last Author",
    "percentage": 33.8,
    "volume": 8914
  },
  {
    "id": "Public Health",
    "group": "Last Author",
    "percentage": 46.4,
    "volume": 75171
  },
  {
    "id": "Pulmonary Medicine",
    "group": "Last Author",
    "percentage": 26,
    "volume": 30991
  },
  {
    "id": "Radiology",
    "group": "Last Author",
    "percentage":23.3,
    "volume": 41902
  },
  {
    "id": "Radiotherapy",
    "group": "Last Author",
    "percentage": 20.2,
    "volume": 2024
  },
  {
    "id": "Reproductive Medicine",
    "group": "Last Author",
    "percentage": 40.9,
    "volume": 22812
  },
  {
    "id": "Rheumatology",
    "group": "Last Author",
    "percentage": 30.8,
    "volume": 35091
  },
  {
    "id": "Sexually Transmitted Diseases",
    "group": "Last Author",
    "percentage": 47.8,
    "volume": 3719
  },
  {
    "id": "Social Sciences",
    "group": "Last Author",
    "percentage": 50,
    "volume": 8215
  },
  {
    "id": "Speech-Language Pathology",
    "group": "Last Author",
    "percentage": 64,
    "volume": 4816
  },
  {
    "id": "Sports Medicine",
    "group": "Last Author",
    "percentage": 28.1,
    "volume": 6638
  },
  {
    "id": "Statistics as Topics",
    "group": "Last Author",
    "percentage": 27.2,
    "volume": 4469
  },
  {
    "id": "Substance-Related Disorders",
    "group": "Last Author",
    "percentage": 39.9,
    "volume": 25836
  },
  {
    "id": "Therapeutics",
    "group": "Last Author",
    "percentage": 33.4,
    "volume": 68737
  },
  {
    "id": "Toxicology",
    "group": "Last Author",
    "percentage": 32.6,
    "volume": 61260
  },
  {
    "id": "Transplantation",
    "group": "Last Author",
    "percentage": 22.4,
    "volume": 25379
  },
  {
    "id": "Traumatology",
    "group": "Last Author",
    "percentage": 22.7,
    "volume": 33590
  },
  {
    "id": "Tropical Medicine",
    "group": "Last Author",
    "percentage": 31.7,
    "volume": 15186
  },
  {
    "id": "Unclassified",
    "group": "Last Author",
    "percentage": 31.2,
    "volume": 151321
  },
  {
    "id": "Urology",
    "group": "Last Author",
    "percentage": 13.8,
    "volume": 55079
  },
  {
    "id": "Vascular Diseases",
    "group": "Last Author",
    "percentage": 23,
    "volume": 43769
  },
  {
    "id": "Veterinary Medicine",
    "group": "Last Author",
    "percentage": 35.1,
    "volume": 30642
  },
    {
    "id": "AIDS",
    "group": "Single Author",
    "percentage": 47.8,
    "volume": 4534
  },
  {
    "id": "Allergy and Immunology",
    "group": "Single Author",
    "percentage": 26.6,
    "volume": 3976
  },
  {
    "id": "Anatomy",
    "group": "Single Author",
    "percentage": 28.8,
    "volume": 1085
  },
  {
    "id": "Anesthesiology",
    "group": "Single Author",
    "percentage": 20.3,
    "volume": 5317
  },
  {
    "id": "Anthropology",
    "group": "Single Author",
    "percentage": 35.1,
    "volume": 1094
  },
  {
    "id": "Anti-infective Agents",
    "group": "Single Author",
    "percentage": 21.2,
    "volume": 1122
  },
  {
    "id": "Audiology",
    "group": "Single Author",
    "percentage": 33.3,
    "volume": 908
  },
  {
    "id": "Behavioral Sciences",
    "group": "Single Author",
    "percentage": 42.8,
    "volume": 2667
  },
  {
    "id": "Biochemistry",
    "group": "Single Author",
    "percentage": 23.9,
    "volume": 12193
  },
  {
    "id": "Bioinformatics",
    "group": "Single Author",
    "percentage": 11.9,
    "volume": 938
  },
  {
    "id": "Biology",
    "group": "Single Author",
    "percentage": 25,
    "volume": 15197
  },
  {
    "id": "Biomedical Engineering",
    "group": "Single Author",
    "percentage": 19.1,
    "volume": 2227
  },
  {
    "id": "Biophysics",
    "group": "Single Author",
    "percentage": 14.5,
    "volume": 6798
  },
  {
    "id": "Biotechnology",
    "group": "Single Author",
    "percentage": 28.4,
    "volume": 5042
  },
  {
    "id": "Botany",
    "group": "Single Author",
    "percentage": 28.2,
    "volume": 2567
  },
  {
    "id": "Brain",
    "group": "Single Author",
    "percentage": 21.2,
    "volume": 2967
  },
  {
    "id": "Cardiology",
    "group": "Single Author",
    "percentage": 18.4,
    "volume": 24673
  },
  {
    "id": "Cell Biology",
    "group": "Single Author",
    "percentage": 28.9,
    "volume": 9814
  },
  {
    "id": "Chemistry",
    "group": "Single Author",
    "percentage": 15.4,
    "volume": 10735
  },
  {
    "id": "Chemistry Techniques, Analytical",
    "group": "Single Author",
    "percentage": 21.1,
    "volume": 4152
  },
  {
    "id": "Clinical Laboratory Techniques",
    "group": "Single Author",
    "percentage": 45.4,
    "volume": 1604
  },
  {
    "id": "Communicable Diseases",
    "group": "Single Author",
    "percentage": 27.4,
    "volume": 4384
  },
  {
    "id": "Complementary Therapies",
    "group": "Single Author",
    "percentage": 26.9,
    "volume": 1180
  },
  {
    "id": "Computational Biology",
    "group": "Single Author",
    "percentage": 34.4,
    "volume": 722
  },
  {
    "id": "Critical Care",
    "group": "Single Author",
    "percentage": 50,
    "volume": 3009
  },
  {
    "id": "Dentistry",
    "group": "Single Author",
    "percentage": 22.9,
    "volume": 19055
  },
  {
    "id": "Dermatology",
    "group": "Single Author",
    "percentage": 27.9,
    "volume": 7359
  },
  {
    "id": "Diagnostic Imaging",
    "group": "Single Author",
    "percentage": 25,
    "volume": 1964
  },
  {
    "id": "Drug Therapy",
    "group": "Single Author",
    "percentage": 39,
    "volume": 2921
  },
  {
    "id": "Emergency Medicine",
    "group": "Single Author",
    "percentage": 14.3,
    "volume": 918
  },
  {
    "id": "Endocrinology",
    "group": "Single Author",
    "percentage": 41,
    "volume": 9983
  },
  {
    "id": "Environmental Health",
    "group": "Single Author",
    "percentage": 34.4,
    "volume": 8185
  },
  {
    "id": "Epidemiology",
    "group": "Single Author",
    "percentage": 25.1,
    "volume": 3619
  },
  {
    "id": "Ethics",
    "group": "Single Author",
    "percentage": 42.5,
    "volume": 6965
  },
  {
    "id": "Gastroenterology",
    "group": "Single Author",
    "percentage": 24.6,
    "volume": 14985
  },
  {
    "id": "General Surgery",
    "group": "Single Author",
    "percentage": 14,
    "volume": 30021
  },
  {
    "id": "Genetics",
    "group": "Single Author",
    "percentage": 38.3,
    "volume": 6293
  },
  {
    "id": "Genetics, Medical",
    "group": "Single Author",
    "percentage": 18.4,
    "volume": 751
  },
  {
    "id": "Geriatrics",
    "group": "Single Author",
    "percentage": 43.2,
    "volume": 4692
  },
  {
    "id": "Gynecology",
    "group": "Single Author",
    "percentage": 37.2,
    "volume": 7248
  },
  {
    "id": "Health Services",
    "group": "Single Author",
    "percentage": 39.6,
    "volume": 22563
  },
  {
    "id": "Health Services Research",
    "group": "Single Author",
    "percentage": 50,
    "volume": 3021
  },
  {
    "id": "Hematology",
    "group": "Single Author",
    "percentage": 25.5,
    "volume": 7413
  },
  {
    "id": "History of Medicine",
    "group": "Single Author",
    "percentage": 32.6,
    "volume": 2627
  },
  {
    "id": "Hospitals",
    "group": "Single Author",
    "percentage": 48.9,
    "volume": 4828
  },
  {
    "id": "Immunology",
    "group": "Single Author",
    "percentage": 39,
    "volume": 6970
  },
  {
    "id": "Internal Medicine",
    "group": "Single Author",
    "percentage": 29.4,
    "volume": 844
  },
  {
    "id": "Jurisprudence",
    "group": "Single Author",
    "percentage": 37.8,
    "volume": 1670
  },
  {
    "id": "Laboratory Animal Science",
    "group": "Single Author",
    "percentage": 48.9,
    "volume": 1564
  },
  {
    "id": "Medical Informatics",
    "group": "Single Author",
    "percentage": 29.9,
    "volume": 3083
  },
  {
    "id": "Medicine",
    "group": "Single Author",
    "percentage": 31.6,
    "volume": 238560
  },
  {
    "id": "Metabolism",
    "group": "Single Author",
    "percentage": 17.8,
    "volume": 2403
  },
  {
    "id": "Microbiology",
    "group": "Single Author",
    "percentage": 37.1,
    "volume": 6414
  },
  {
    "id": "Midwifery",
    "group": "Single Author",
    "percentage": 89.1,
    "volume": 4319
  },
  {
    "id": "Molecular Biology",
    "group": "Single Author",
    "percentage": 31.5,
    "volume": 10536
  },
  {
    "id": "Multidisciplinary",
    "group": "Single Author",
    "percentage": 31,
    "volume": 38841
  },
  {
    "id": "Nanotechnology",
    "group": "Single Author",
    "percentage": 25.7,
    "volume": 1229
  },
  {
    "id": "Neoplasms",
    "group": "Single Author",
    "percentage": 38.8,
    "volume": 27024
  },
  {
    "id": "Nephrology",
    "group": "Single Author",
    "percentage": 34.1,
    "volume": 7297
  },
  {
    "id": "Neurology",
    "group": "Single Author",
    "percentage": 24.3,
    "volume": 36048
  },
  {
    "id": "Nursing",
    "group": "Single Author",
    "percentage": 75,
    "volume": 74098
  },
  {
    "id": "Nutritional Sciences",
    "group": "Single Author",
    "percentage": 42,
    "volume": 8416
  },
  {
    "id": "Obstetrics",
    "group": "Single Author",
    "percentage": 30.8,
    "volume": 1242
  },
  {
    "id": "Occupational Medicine",
    "group": "Single Author",
    "percentage": 28.4,
    "volume": 2774
  },
  {
    "id": "Opthalmology",
    "group": "Single Author",
    "percentage": 17.2,
    "volume": 10905
  },
  {
    "id": "Orthodontics",
    "group": "Single Author",
    "percentage": 9.3,
    "volume": 1696
  },
  {
    "id": "Orthopedics",
    "group": "Single Author",
    "percentage": 11.6,
    "volume": 5314
  },
  {
    "id": "Otolaryngology",
    "group": "Single Author",
    "percentage": 18.8,
    "volume": 2639
  },
  {
    "id": "Palliative Care",
    "group": "Single Author",
    "percentage": 47.7,
    "volume": 1290
  },
  {
    "id": "Parasitology",
    "group": "Single Author",
    "percentage": 35.3,
    "volume": 1403
  },
  {
    "id": "Pathology",
    "group": "Single Author",
    "percentage": 28.2,
    "volume": 3336
  },
  {
    "id": "Pediatrics",
    "group": "Single Author",
    "percentage": 36.4,
    "volume": 20317
  },
  {
    "id": "Perinatology",
    "group": "Single Author",
    "percentage": 61.9,
    "volume": 1552
  },
  {
    "id": "Pharmacology",
    "group": "Single Author",
    "percentage": 35,
    "volume": 22313
  },
  {
    "id": "Physical and Rehabilitation Medicine",
    "group": "Single Author",
    "percentage": 52.4,
    "volume": 3069
  },
  {
    "id": "Physiology",
    "group": "Single Author",
    "percentage": 22.1,
    "volume": 7741
  },
  {
    "id": "Primary Health Care",
    "group": "Single Author",
    "percentage": 31.8,
    "volume": 9794
  },
  {
    "id": "Psychiatry",
    "group": "Single Author",
    "percentage": 31.1,
    "volume": 21591
  },
  {
    "id": "Psychology",
    "group": "Single Author",
    "percentage": 34.8,
    "volume": 17904
  },
  {
    "id": "Psychopharmacology",
    "group": "Single Author",
    "percentage": 16.8,
    "volume": 1091
  },
  {
    "id": "Psychophysiology",
    "group": "Single Author",
    "percentage": 32.9,
    "volume": 804
  },
  {
    "id": "Public Health",
    "group": "Single Author",
    "percentage": 41.6,
    "volume": 14016
  },
  {
    "id": "Pulmonary Medicine",
    "group": "Single Author",
    "percentage": 20.7,
    "volume": 4985
  },
  {
    "id": "Radiology",
    "group": "Single Author",
    "percentage":22.6,
    "volume": 7435
  },
  {
    "id": "Reproductive Medicine",
    "group": "Single Author",
    "percentage": 49.9,
    "volume": 2745
  },
  {
    "id": "Rheumatology",
    "group": "Single Author",
    "percentage": 36.6,
    "volume": 4446
  },
  {
    "id": "Social Sciences",
    "group": "Single Author",
    "percentage": 51.6,
    "volume": 2889
  },
  {
    "id": "Speech-Language Pathology",
    "group": "Single Author",
    "percentage": 62.4,
    "volume": 949
  },
  {
    "id": "Statistics as Topics",
    "group": "Single Author",
    "percentage": 17.6,
    "volume": 974
  },
  {
    "id": "Substance-Related Disorders",
    "group": "Single Author",
    "percentage": 33.1,
    "volume": 3510
  },
  {
    "id": "Therapeutics",
    "group": "Single Author",
    "percentage": 20.9,
    "volume": 1464
  },
  {
    "id": "Toxicology",
    "group": "Single Author",
    "percentage": 27.1,
    "volume": 3987
  },
  {
    "id": "Transplantation",
    "group": "Single Author",
    "percentage": 26.7,
    "volume": 2651
  },
  {
    "id": "Traumatology",
    "group": "Single Author",
    "percentage": 25.6,
    "volume": 3086
  },
  {
    "id": "Tropical Medicine",
    "group": "Single Author",
    "percentage": 14.2,
    "volume": 947
  },
  {
    "id": "Unclassified",
    "group": "Single Author",
    "percentage": 28.1,
    "volume": 25120
  },
  {
    "id": "Urology",
    "group": "Single Author",
    "percentage": 12.6,
    "volume": 13282
  },
  {
    "id": "Vascular Diseases",
    "group": "Single Author",
    "percentage": 18.3,
    "volume": 5225
  },
  {
    "id": "Veterinary Medicine",
    "group": "Single Author",
    "percentage": 39.7,
    "volume": 8151
  }
]